/**
 * Order Pickup Service
 * Handles HTTP requests for order pickup operations
 * Pure service layer - no business logic, just HTTP calls
 */

import { orderPickup as orderPickupApi } from "@/helpers/apiHelper";

/**
 * Submits order pickup notification
 * @param {Object} params
 * @param {string|number} params.orderId - Order ID
 * @param {string} params.carModel - Car model and color
 * @param {string} params.parkingNumber - Parking spot number
 * @param {string|null} params.token - Authentication token (optional)
 * @returns {Promise<any>} API response
 */
export async function submitOrderPickup({
  orderId,
  carModel,
  parkingNumber,
  token
}) {
  return orderPickupApi(orderId, carModel, parkingNumber, token);
}
